<template>
  <div id="application-wrapper" :style="cssVars" v-if="loaded">
    <Transition name="slide-fade">
      <media-player v-if="$store.state.audioTrack" />
    </Transition>
    <router-view name="header"></router-view>
    <router-view name="navigation"></router-view>
    <router-view name="main"></router-view>
    <router-view name="chat"></router-view>
  </div>
</template>

<script>
/* eslint-disable */
import { hexToRgb } from "./Helpers/style.js";
import MediaPlayer from "./Components/MediaPlayer/MediaPlayer.vue";
import Messaging from "./Components/Messaging/Messaging.vue";

export default {
  data() {
    return {
      loaded: true,
      defaultColors: {
        background: "#FFFFFF",
        contrast: "#212121",
        accent: "#FFD1D1",
        secondary: "#D9D9D9",
      },
      subscriptionExpired: false,
      subscriptionNonExistent: false,
    };
  },
  computed: {
    colorTheme() {
      return this.$store.getters.colorTheme;
    },
    accentColor() {
      return this.$store.getters.highlightColor;
    },
    shadow() {
      let hex = hexToRgb(this.defaultColors.contrast);
      return `rgba(${hex.r}, ${hex.g}, ${hex.b}, .25)`;
    },
    cssVars() {
      return {
        // todo : change config to comply to new branding standards
        // todo : create function to convert choices to new standards
        // todo : clean up comments
        "--shadow": this.shadow,
        "--backgroundColor": this.colorTheme
          ? this.colorTheme[0]
          : this.defaultColors.background,
        "--secondaryColor": this.colorTheme
          ? this.colorTheme[1]
          : this.defaultColors.secondary,
        "--contrastColor": this.colorTheme
          ? this.colorTheme[2]
          : this.defaultColors.contrast,
        "--accentColor": this.accentColor
          ? this.accentColor
          : this.defaultColors.accent,
      };
    },
  },
  components: {
    Messaging,
    MediaPlayer,
  },

  async created() {
    document.title = this.$store.getters.businessName;
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,400&display=swap");
@media screen {
  html,
  body {
    width: 100%;
    margin: 0px;
    padding: 0px;
    /* overflow: hidden; */
  }

  #app {
    font-family: Raleway, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    height: 100vh;
    width: 100vw;
  }

  a {
    text-decoration: none;
  }
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.3s ease-out;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }
  @media screen {
    @media screen {
      #application-wrapper {
        -webkit-transition: background-color 1000ms linear, color 1000ms linear;
        -moz-transition: background-color 1000ms linear, color 1000ms linear;
        -o-transition: background-color 1000ms linear, color 1000ms linear;
        -ms-transition: background-color 1000ms linear, color 1000ms linear;
        transition: background-color 1000ms linear, color 1000ms linear;
        background-color: var(--backgroundColor);
        width: 100%;
        min-height: 100vh;
        display: flex;
        padding: 100px 25px 25px;
        box-sizing: border-box;
        overflow-y: visible;
        overflow-x: hidden;
        color: var(--contrastColor);
      }
    }
    @media (min-width: 800px) {
      #application-wrapper {
        padding: 100px 50px 50px;
      }
    }
  }
}
@media print {
  @page {
    margin: 20mm;
  }
  html,
  body {
    width: 100%;
    /* height: 100%; */
    /* max-height: 100%; */
    height: auto;
    margin: 0px;
    padding: 0px;
    overflow: visible !important;
    overflow: none;
    /* position: fixed; */
  }

  #app {
    height: auto;
    width: auto;
    overflow: visible !important;
    overflow: none;
    display: block;
  }

  input,
  select,
  textarea {
    color: #212121;
    background-color: white;
    border: 1px solid;
    border-radius: 5px;
    padding: 3px;
  }

  input::placeholder {
    opacity: 0;
  }
  .no-print {
    display: none;
  }
  #application-wrapper {
    overflow: visible !important;
    overflow: none;
    height: auto;
    background-color: var(--backgroundColor);
    display: block;
  }
}
</style>